<template>
    <div>
        <modal v-model="toggleModal" v-on="$listeners"
               :title="trans('general.observations.add_note')" ref="modal">
            <basic-form v-if="model" :action="action" @submit="recordDevelopment" ref="from"
                        :use-default-submit="false" :submit-class="model.id ? 'btn-save btn-secondary ' : 'btn-new btn-secondary '">
                <form-input-builder :fields="formFields" v-model="model"></form-input-builder>
            </basic-form>
        </modal>
    </div>
</template>

<script>
import FormInputBuilder from "../../../theme/molecules/FormInputBuilder.vue";
import BasicForm from "../../../theme/molecules/BasicForm.vue";
import DropDownButton from "../../../theme/atoms/DropDownButton.vue";
import Modal from "../../../theme/organisms/Modal.vue";
import axios from "axios";
import {REPORT_TYPE} from "../../../services/Defaults";

export default {
  name: "ObservationTopicNoteModal",
  components: {
    Modal,
    BasicForm,
    FormInputBuilder,
    DropDownButton
  },
  data() {
    return {
      toggleModal: false,
      model: null,
      action: null,
      deleteOptions: [],
      formFields: [
        {
          type: 'textarea',
          name: 'note',
          label: trans('general.module.report.note'),
        }
      ]
    }
  },
  methods: {
    open(data) {
      this.model = data;
      this.toggleModal = true;
    },
    recordDevelopment() {
      const form = this.getReportForm();
      axios.post('/child-report/new', form, {headers: {'content-type': 'multipart/form-data'}})
          .then(response => {
            this.onSuccess();
          })
    },
    getReportForm() {
      const form = new FormData();

      form.append('children_ids[]', this.model.childId);
      form.append('model', REPORT_TYPE.DEVELOPMENT);
      form.append('show_on_daily', false)
      form.append(`assessments[0][topic]`, this.model.topic)
      form.append(`assessments[0][development_topic_id]`,  this.model.development_topic_id)
      form.append(`assessments[0][note]`, this.model.note)

      return form;
    },
    onSuccess() {
      this.toggleModal = false;
      this.$emit('success');
    }
  }
}

</script>
